<template>
  <div class="Reward" v-if="daily_info">
    <div class="main">
      <div class="main_item">
        <p class="main_title">Login Daily Reward</p>
        <el-form :model="daily_info.daily_reward" label-width="100px">
          <el-form-item label="Login Day 1">
            <el-input-number v-model="daily_info.daily_reward.login_day_1" :min="1"
                             label="Enter Reward"></el-input-number>
          </el-form-item>
          <el-form-item label="Login Day 2">
            <el-input-number v-model="daily_info.daily_reward.login_day_2" :min="1"
                             label="Enter Reward"></el-input-number>
          </el-form-item>
          <el-form-item label="Login Day 3">
            <el-input-number v-model="daily_info.daily_reward.login_day_3" :min="1"
                             label="Enter Reward"></el-input-number>
          </el-form-item>
          <el-form-item label="Login Day 4">
            <el-input-number v-model="daily_info.daily_reward.login_day_4" :min="1"
                             label="Enter Reward"></el-input-number>
          </el-form-item>
          <el-form-item label="Login Day 5">
            <el-input-number v-model="daily_info.daily_reward.login_day_5" :min="1"
                             label="Enter Reward"></el-input-number>
          </el-form-item>
          <el-form-item label="Login Day 6">
            <el-input-number v-model="daily_info.daily_reward.login_day_6" :min="1"
                             label="Enter Reward"></el-input-number>
          </el-form-item>
          <el-form-item label="Login Day 7+">
            <el-input-number v-model="daily_info.daily_reward.login_day_7" :min="1"
                             label="Enter Reward"></el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <div class="main_item">
        <p class="main_title">Clockin Daily Reward</p>
        <el-form :model="daily_info.daily_reward" label-width="120px">
          <el-form-item label="Clockin Day 1">
            <el-input-number v-model="daily_info.daily_reward.clockin_day_1" :min="1"
                             label="Enter Reward"></el-input-number>
          </el-form-item>
          <el-form-item label="Clockin Day 2">
            <el-input-number v-model="daily_info.daily_reward.clockin_day_2" :min="1"
                             label="Enter Reward"></el-input-number>
          </el-form-item>
          <el-form-item label="Clockin Day 3">
            <el-input-number v-model="daily_info.daily_reward.clockin_day_3" :min="1"
                             label="Enter Reward"></el-input-number>
          </el-form-item>
          <el-form-item label="Clockin Day 4">
            <el-input-number v-model="daily_info.daily_reward.clockin_day_4" :min="1"
                             label="Enter Reward"></el-input-number>
          </el-form-item>
          <el-form-item label="Clockin Day 5">
            <el-input-number v-model="daily_info.daily_reward.clockin_day_5" :min="1"
                             label="Enter Reward"></el-input-number>
          </el-form-item>
          <el-form-item label="Clockin Day 6">
            <el-input-number v-model="daily_info.daily_reward.clockin_day_6" :min="1"
                             label="Enter Reward"></el-input-number>
          </el-form-item>
          <el-form-item label="Clockin Day 7+">
            <el-input-number v-model="daily_info.daily_reward.clockin_day_7" :min="1"
                             label="Enter Reward"></el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <div class="main_item">
        <p class="main_title">Daily Mindfulness First Time Reward</p>
        <el-form :model="daily_info.daily_reward" label-width="140px">
          <el-form-item label="Mindfulness Day 1">
            <el-input-number v-model="daily_info.daily_reward.mindfulness_day_1" :min="1"
                             label="Enter Reward"></el-input-number>
          </el-form-item>
          <el-form-item label="Mindfulness Day 2">
            <el-input-number v-model="daily_info.daily_reward.mindfulness_day_2" :min="1"
                             label="Enter Reward"></el-input-number>
          </el-form-item>
          <el-form-item label="Mindfulness Day 3">
            <el-input-number v-model="daily_info.daily_reward.mindfulness_day_3" :min="1"
                             label="Enter Reward"></el-input-number>
          </el-form-item>
          <el-form-item label="Mindfulness Day 4">
            <el-input-number v-model="daily_info.daily_reward.mindfulness_day_4" :min="1"
                             label="Enter Reward"></el-input-number>
          </el-form-item>
          <el-form-item label="Mindfulness Day 5">
            <el-input-number v-model="daily_info.daily_reward.mindfulness_day_5" :min="1"
                             label="Enter Reward"></el-input-number>
          </el-form-item>
          <el-form-item label="Mindfulness Day 6">
            <el-input-number v-model="daily_info.daily_reward.mindfulness_day_6" :min="1"
                             label="Enter Reward"></el-input-number>
          </el-form-item>
          <el-form-item label="Mindfulness Day 7+">
            <el-input-number v-model="daily_info.daily_reward.mindfulness_day_7" :min="1"
                             label="Enter Reward"></el-input-number>
          </el-form-item>
        </el-form>
      </div>

      <div class="main_item">
        <p class="main_title">Clockin Time</p>
        <el-time-picker
            format="HH:mm"
            value-format="HH:mm"
            is-range
            :default-value="time_range"
            v-model="time_range"
            range-separator="to"
            start-placeholder="Start Time"
            end-placeholder="End time"
            placeholder="Pick time range">
        </el-time-picker>
      </div>
    </div>
    <div>
      <el-button style="margin-top: 20px;margin-left: 480px;width: 200px"
                 type="primary"
                 :disabled="!time_range"
                 @click="onSaveAll">Save All
      </el-button>
    </div>
  </div>
</template>

<script>
  import {getDailyInfo, saveDailyInfo} from "@/utils/api";

  export default {
    props: {},
    data: () => {
      return {
        daily_info: false,
        time_range: false
      }
    },
    methods: {
      onSaveAll() {
        let daily_reward = this.daily_info.daily_reward;
        let clockin_time = {
          start_time: this.time_range[0],
          end_time: this.time_range[1]
        };
        saveDailyInfo({
          daily_reward: daily_reward,
          clockin_time: clockin_time
        }).then(res => {
          if (res.errcode === 0) {
            this.$message.success('Saved');
            getDailyInfo().then(res => {
              this.daily_info = res.daily_info;
              this.time_range = [res.daily_info.clockin_time.start_time, res.daily_info.clockin_time.end_time]
            })
          } else {
            this.$message.error('Error')
          }
        })
      }
    },
    beforeMount() {
      getDailyInfo().then(res => {
        this.daily_info = res.daily_info;
        this.time_range = [res.daily_info.clockin_time.start_time, res.daily_info.clockin_time.end_time]
      })
    }
  };
</script>


<style lang="scss" scoped>
  @import "_Reward.scss";
</style>